import { useTranslation } from 'react-i18next';

export default function SecuritySafety() {
  const { t } = useTranslation();

  const securityFeatures = [
    {
      title: t('security_alarm'),
      description: t('security_alarm_desc')
    },
    {
      title: t('security_cameras'),
      description: t('security_cameras_desc')
    },
    {
      title: t('security_windows'),
      description: t('security_windows_desc')
    },
    {
      title: t('security_doors'),
      description: t('security_doors_desc')
    }
  ];

  return (
    <section className="py-24 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold mb-12 text-gray-900 text-center">
          {t('security_title')}
        </h2>

        <div className="flex flex-col items-center">
          <p className="text-gray-700 text-lg leading-relaxed mb-8 text-center max-w-3xl">
            {t('security_intro')}
          </p>

          {/* Main Security Features */}
          <div className="w-full max-w-3xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              {t('security_features_heading')}
            </h3>
            
            <div className="space-y-6">
              {securityFeatures.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-gray-900 rounded-full mt-2 flex-shrink-0"></div>
                  <div className="flex-1">
                    <h4 className="text-gray-900 font-bold text-lg mb-2">
                      {feature.title}
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
